<template>
  <div :class="$.card">
    <div :class="$.header">
      <div
        :class="$.upper"
        v-if="config.includes('header_upper')"
      >
        <skeleton-item
          type="bar"
          :style="{ height: '12px', width: '192px' }"
        />
      </div>
      <div :class="$.lower">
        <div :class="$.left">
          <skeleton-item
            type="square"
            size="sm"
          />
        </div>
        <div :class="$.right">
          <skeleton-item
            :class="$.item"
            v-if="config.includes('header_lower_right_upper')"
            type="bar"
            :style="{ height: '12px', width: '192px'}"
          />
          <skeleton-item
            :class="$.item"
            type="bar"
            width="big"
            :style="{ height: '12px'}"
          />
        </div>
      </div>
    </div>
    <div :class="$.main">
      <skeleton-item
        type="bar"
        :style="{ height: '20px', width: '72px'}"
      />
      <skeleton-item
        type="circle"
        size="sm"
      />
    </div>
    <div :class="$.footer">
      <skeleton-item
        type="bar"
        :style="{ height: '12px', width: '100px'}"
      />
      <skeleton-item
        v-if="config.includes('footer_right')"
        type="square"
        size="bg"
      />
    </div>
  </div>
</template>

<script>
import SkeletonItem from '../../common/VueComponents/skeletons/skeletonItem.vue';

export default {
  name: 'CardSkeleton',
  components: {
    SkeletonItem
  },
  props: {
    type: {
      type: String,
      default: 'S',
      validator(value) {
        return [
          'L', // large
          'S' // small
        ].includes(value)
      }
    }
  },
  computed: {
    config() {
      switch (this.type) {
        case 'S':
          return ['footer_right'];
        case 'L':
          return ['header_upper', 'header_lower_right_upper'];
        default:
          return [];
      }
    }
  }
}
</script>

<style lang="less" module="$" src="../less/cardSkeleton.less"></style>
